import { Component, inject } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { BandejaService } from "../services/bandeja/bandeja.service";
import { MatCardModule } from "@angular/material/card";
import { CommonModule } from "@angular/common";
import { IBandejaTareas, ITab } from "../interfaces/bandeja";
import { MatButtonModule } from "@angular/material/button";
import { LoadingService } from "../loading/loading.service";
import { Router, RouterLink } from "@angular/router";
import { AppState } from "../app.state";
import { Store, select } from "@ngrx/store";
import { selectUsuario } from "../states/usuario/selector";
import { firstValueFrom, take } from "rxjs";
import { UsuarioService } from "../usuario/usuario.service";
@Component({
  selector: "app-bandeja",
  standalone: true,
  imports: [
    MatTabsModule,
    MatCardModule,
    CommonModule,
    MatButtonModule,
    RouterLink,
  ],
  templateUrl: "./bandeja.component.html",
  styleUrl: "./bandeja.component.css",
})
export class BandejaComponent {
  tasks: IBandejaTareas[] = [];
  tasksAsignadoA: IBandejaTareas[] = [];
  tasksSupervisor: IBandejaTareas[] = [];
  tasksCordinador: IBandejaTareas[] = [];
  tasksEjecucion: IBandejaTareas[] = [];
  tabs: ITab[] = [];
  tasksLoaded = false;
  previousUserId: string | null = null;
  private readonly store: Store<AppState> = inject(Store);
  private readonly stateUser: any = this.store.pipe(select(selectUsuario));
  user: any;

  constructor(
    private bandejaService: BandejaService,
    private loadingService: LoadingService,
    private router: Router,
    private usuarioService: UsuarioService
  ) {}
  async ngOnInit() {
    this.loadingService.show();
    const oUsuario: any = await firstValueFrom(
      this.usuarioService.getUsuario()
    );
    this.user = oUsuario ?? null;
    
    if (
      this.user?.uid &&
      this.user.uid !== this.previousUserId &&
      !this.tasksLoaded
    ) {
      try {
          const resBandeja = await this.bandejaService.obtenerBandeja(
            this.user.uid,
            this.user.rol
          );
        this.tasksLoaded = true;
        this.previousUserId = this.user.uid;
        this.tasks = resBandeja;
        this.loadingService.hide();

        this.agrupaPorEstatus(resBandeja);

      } catch (error) {
        console.log("error", error);
          this.loadingService.hide();
      }
    
    } else if (!this.user.uid) {
      this.resetTasks();
    }
  }

  verEntrada(item: IBandejaTareas) {
    this.router.navigate([`/entrada/${item.tema}/${item.entrada}`]);
  }

  agrupaPorEstatus(tareas: IBandejaTareas[]) {
    Object.values(tareas).forEach((entrada) => {
      switch (entrada.estatus) {
        case 1:
          this.tasksAsignadoA.push(entrada);
          break;
        case 2:
          this.tasksSupervisor.push(entrada);
          break;
        case 3:
          this.tasksCordinador.push(entrada);
          break;
        case 4:
          this.tasksEjecucion.push(entrada);
          break;
        default:
          console.log("error");
          break;
      }
    });

    this.filtrarPorRol();
  }

  filtrarPorRol() {
    switch (this.user.rol) {
      case 2: // Supervisor
        const tabSupervisor: ITab[] = [
          {
            label: "Enviado a Supervisor",
            tasks: this.tasksSupervisor,
            tabId: 1,
          },
          {
            label: "Enviado a Coordinador",
            tasks: this.tasksCordinador,
            tabId: 2,
          },
          {
            label: "Enviado a Ejecución",
            tasks: this.tasksEjecucion,
            tabId: 3,
          },
          {
            label: "Asignado a",
            tasks: this.tasksAsignadoA,
            tabId: 4,
          },
        ];
        this.tabs.push(...tabSupervisor);
        break;

      case 3:
        const tabCoordinador: ITab[] = [
          {
            label: "Enviado a Coordinador",
            tasks: this.tasksCordinador,
            tabId: 1,
          },
          {
            label: "Enviado a Ejecución",
            tasks: this.tasksEjecucion,
            tabId: 2,
          },
          {
            label: "Asignado a",
            tasks: this.tasksAsignadoA,
            tabId: 3,
          },
          {
            label: "Enviado a Supervisor",
            tasks: this.tasksSupervisor,
            tabId: 4,
          },
        ];
        this.tabs.push(...tabCoordinador);
        break;

      default:
        const tabOtrosRoles: ITab[] = [
          {
            label: "Asignado a",
            tasks: this.tasksAsignadoA,
            tabId: 1,
          },
          {
            label: "Enviado a Supervisor",
            tasks: this.tasksSupervisor,
            tabId: 2,
          },
          {
            label: "Enviado a Coordinador",
            tasks: this.tasksCordinador,
            tabId: 3,
          },
          {
            label: "Enviado a Ejecución",
            tasks: this.tasksEjecucion,
            tabId: 4,
          },
        ];
        this.tabs.push(...tabOtrosRoles);
        break;
    }

    this.tabs.sort((a, b) => a.tabId - b.tabId);
    console.log("filtrarPorRol", this.tabs);
  }

  resetTasks() {
    this.tabs = [];
    this.tasksAsignadoA = [];
    this.tasksCordinador = [];
    this.tasksEjecucion = [];
    this.tasksSupervisor = [];
  }
}
